import { RefObject } from 'react';

import useOnClickOutside from 'use-onclickoutside';

const MOUSEDOWN = 'mousedown';
const TOUCHSTART = 'touchstart';
type HandledEvents = [typeof MOUSEDOWN, typeof TOUCHSTART];
type HandledEventsType = HandledEvents[number];
type PossibleEvent = {
  [Type in HandledEventsType]: HTMLElementEventMap[Type];
}[HandledEventsType];
type Handler = (event: PossibleEvent) => void;

const hasClass = (element: Element, className: string) =>
  element.classList.contains(className);

const isInIgnoredElement = (
  element: Element,
  ignoredClass: string,
): boolean => {
  if (!element) {
    return false;
  }

  if (hasClass(element, ignoredClass)) {
    return true;
  }

  return isInIgnoredElement(element.parentElement as Element, ignoredClass);
};

const useOnClickOutsideWithIgnore = (
  ref: RefObject<HTMLElement>,
  handler: Handler,
  ignoredClass = 'ignore-onClickOutside',
): void =>
  useOnClickOutside(ref, (event: PossibleEvent) => {
    if (isInIgnoredElement(event.target as Element, ignoredClass)) {
      return;
    }

    handler(event);
  });

export default useOnClickOutsideWithIgnore;
